import { __assign } from "tslib";
import { OrderStatus } from '../../../types/enums/ticketing';
import { getAssignedTicket } from './assigned-ticket';
var TicketBuilder = /** @class */ (function () {
    function TicketBuilder() {
        this.ticket = {
            ticketDefinitionId: 'ABC1',
            ticketNumber: 'ABC',
            price: { amount: '10', currency: 'EUR' },
            free: false,
            name: 'TICKET',
            guestDetails: {},
            orderFullName: 'Order Full Name',
            orderStatus: OrderStatus.PAID,
            orderArchived: false,
        };
    }
    TicketBuilder.prototype.withId = function (id) {
        this.ticket.ticketDefinitionId = id;
        return this;
    };
    TicketBuilder.prototype.withMemberId = function (memberId) {
        this.ticket.memberId = memberId;
        return this;
    };
    TicketBuilder.prototype.withPrice = function (price) {
        this.ticket.price = price;
        return this;
    };
    TicketBuilder.prototype.withName = function (name) {
        this.ticket.name = name;
        return this;
    };
    TicketBuilder.prototype.withTicketNumber = function (number) {
        this.ticket.ticketNumber = number;
        return this;
    };
    TicketBuilder.prototype.checkedIn = function (checkedIn) {
        if (checkedIn === void 0) { checkedIn = true; }
        this.ticket.checkIn = checkedIn ? { created: new Date().toISOString() } : null;
        return this;
    };
    TicketBuilder.prototype.withOrderStatus = function (status) {
        this.ticket.orderStatus = status;
        return this;
    };
    TicketBuilder.prototype.withGuestDetails = function (details) {
        this.ticket.guestDetails = details;
        return this;
    };
    TicketBuilder.prototype.withGuestFullName = function (guestFullName) {
        this.ticket.guestFullName = guestFullName;
        return this;
    };
    TicketBuilder.prototype.withOrderFullName = function (orderFullName) {
        this.ticket.orderFullName = orderFullName;
        return this;
    };
    TicketBuilder.prototype.assignedTicket = function () {
        this.ticket = getAssignedTicket();
        return this;
    };
    TicketBuilder.prototype.free = function () {
        this.ticket.free = true;
        return this;
    };
    TicketBuilder.prototype.anonymized = function () {
        this.ticket.anonymized = true;
        return this;
    };
    TicketBuilder.prototype.build = function () {
        return __assign({}, this.ticket);
    };
    return TicketBuilder;
}());
export { TicketBuilder };
//# sourceMappingURL=ticket-builder.js.map